import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import * as fromApp from '../store/app.reducer';
import { map, filter, first } from 'rxjs/operators';
import { inject } from '@angular/core';

export const onboardingGuard = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
): Observable<boolean | UrlTree> => {
    const store = inject(Store<fromApp.AppState>);
    const router = inject(Router);

    return store.select(state => state.auth).pipe(
        // Wait for auth to be properly loaded
        filter(authState => authState?.authChecked && !!authState?.employee),
        first(),
        map(authState => {
            // Validate auth state
            if (!authState || !authState?.employee) {
                console.error('Invalid auth state in onboarding guard');
                return router.createUrlTree(['/login']);
            }

            // Check if employee object is valid and has customers array
            if (!Array.isArray(authState?.employee?.customers)) {
                console.error('Invalid employee state detected:', authState?.employee);
                return router.createUrlTree(['/login']);
            }

            // If user already has customers, redirect to assignments
            if (authState?.employee?.customers?.length > 0) {
                return router.createUrlTree(['/components/assignments']);
            }

            // Allow access to onboarding
            return true;
        })
    );
};